
import React, { useState, useEffect } from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './index.css'
export default () => {
    useEffect(() => {
        initSwiper();
    }, []);


    const initSwiper = () => {

        // swiper效果设置
        var mySwiper = new window.Swiper('.swiper-container', {
            //是否循环
            loop: true,
            loopedSlides: 5,
            centeredSlides: true,


            //切换速度
            speed: 1000,
            //初始页面号
            initialSlide: 2,

            //是否需要按钮
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            // 自动播放
            autoplay: true,
            autoplay: {
                delay: 4000,//5秒切换一次
            },


            //分页器，即小圆点
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

            uniqueNavElements: false,

            //播放效果
            effect: 'coverflow',
            slidesPerView: 2,
            centeredSlides: true,
            coverflowEffect: {
                rotate: 0,
                stretch: 120,
                depth: 300,
                modifier: 2,
                slideShadows: false,
            },
        })

    }





    return (
        <div className='swiper-part'>
            <div className='swiper-visible'>
                <div className="swiper-container" >

                    {/* 以下都为swpiper代码 */}
                    <div className="swiper-wrapper">
                        <div className="swiper-slide">
                            <img className='faultImg' src='//dl.gamdream.com/idfe-MonumentValley-website/img1.6f784138.png' />
                            <img className='realImg' src='//dl.gamdream.com/idfe-MonumentValley-website/img1.6f784138.png' />
                        </div>
                        <div className="swiper-slide">
                            <img className='faultImg' src='//dl.gamdream.com/idfe-MonumentValley-website/img2.6e50b5e4.png' />
                            <img className='realImg' src='//dl.gamdream.com/idfe-MonumentValley-website/img2.6e50b5e4.png' />
                        </div>
                        <div className="swiper-slide">
                            <img className='faultImg' src='//dl.gamdream.com/idfe-MonumentValley-website/img3.2b20e4dd.png' />
                            <img className='realImg' src='//dl.gamdream.com/idfe-MonumentValley-website/img3.2b20e4dd.png' />
                        </div>
                        <div className="swiper-slide">
                            <img className='faultImg' src='//dl.gamdream.com/idfe-MonumentValley-website/img4.290fb059.png' />
                            <img className='realImg' src='//dl.gamdream.com/idfe-MonumentValley-website/img4.290fb059.png' />
                        </div>
                        <div className="swiper-slide">
                            <img className='faultImg' src='//dl.gamdream.com/idfe-MonumentValley-website/img5.5a531455.png' />
                            <img className='realImg' src='//dl.gamdream.com/idfe-MonumentValley-website/img5.5a531455.png' />
                        </div>


                    </div>

                    {/* <!-- 如果需要分页器 --> */}
                    <div className="swiper-pagination"></div>

                    {/* <!-- 如果需要导航按钮 --> */}
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>

                </div>
            </div>
        </div>
    );
}
